import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseUrl } from 'constant'
import { RootState } from 'store/store'
import { getAuthToken } from 'utils/getAuthToken'
import { handlingErrorResponse } from 'utils/HandlingErrorResponse'
import {
    IEmployeeDesignationIdRespones,
    IEmployeeDesignationIdType,
} from './type'
import { getEmployeeByDesignationIdUrl } from './const'

export const getEmployeeByDesignationIdApi = createApi({
    reducerPath: 'getEmployeeByDesignationIdApi',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers, { getState }) => {
            const token = getAuthToken(getState() as RootState)
            if (token) {
                headers.set('Authorization', `Bearer ${token}`)
            }
            return headers
        },
    }),
    tagTypes: ['GetEmployeeByDesignationId'],
    endpoints: (builder) => ({
        GetEmployeeRoleByIdUrl: builder.mutation<IEmployeeDesignationIdRespones, IEmployeeDesignationIdType>({
            query: userReq => ({
                url: getEmployeeByDesignationIdUrl(true),
                method: 'POST',
                body: userReq.designationId
            }),
            transformErrorResponse: handlingErrorResponse,
            invalidatesTags: [{ type: 'GetEmployeeByDesignationId', id: 'GetEmployeeByDesignationId' }],
        }),
    }),
})